import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Estimation de {{orderMethod}} : {{day}} vers {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Commande refusée',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Commande reçue',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Votre commande a été vue',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Commande confirmée',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Commande prête',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Commande en cours de livraison',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Commande terminée',
    },
  },
  labels: {
    today: "Aujourd'hui",
  },
  waiting_confirmation: {
    title: 'En attente de confirmation',
    description: 'Patientez...',
  },
  pickup_time: {
    title: 'Heure de retrait',
    description: 'Confirmé par {{name}}',
  },
  delivery_time: {
    title: 'Heure de livraison',
    description: 'Confirmé par {{name}}',
  },
  warning_label: {
    pickup_time_changed: "{{company}} a modifié l'heure de {{initialTime}} à {{currentTime}}",
  },
};
